import { ThemeProvider, Typography, useTheme } from "@mui/material";
import { PaintMarker } from "../mapa";
import { divIcon, Marker } from "leaflet";

export interface CadastroData {
  id: number;
  idZas: number;
  lat: number;
  lon: number;
  status: string;
  tipo: string;
  icon: string;
  proprietario?: string;
  qtdPessoas?: number;
  qtdComorbidade?: number;
  qtdLocomocao?: number;
  obs?: string;
}

export class Cadastro extends Marker<CadastroData> {
  public paintOptions: PaintMarker;

  public properties: CadastroData;

  constructor(properties: CadastroData, paintOptions: PaintMarker) {
    super([properties.lat, properties.lon], paintOptions);
    this.paintOptions = paintOptions;
    this.properties = properties;

    this.setIcon(divIcon({
      html: this.iconComponent(),
      className: '',
      iconAnchor: [(this.paintOptions.iconSize ?? 20) / 2, this.paintOptions.iconSize ?? 20 / 2],
    }));

    if (paintOptions.bindTooltip) {
      this.bindTooltip(this.tooltipComponent(), { direction: 'top' });
    }

    if (paintOptions.bindPopUp ?? true) {
      this.bindPopup(this.popUpComponent());
    }
  }


  public iconComponent() {
    const component: JSX.Element = (<IconData
      src={this.properties.icon}
      iconSize={this.paintOptions.iconSize ?? 20}
      text={this.properties.status + " " + this.properties.tipo}
    />
    );
    return window.JSXToHTML(component);
  }

  public tooltipComponent() {
    return window.JSXToHTML(
      <div style={{
        width: "10em",
        display: "flex",
        overflowY: "auto",
        justifyItems: "center",
        flexDirection: "column",
      }}>
        <Row title="Tipo:" value={this.properties.tipo} />
      </div>
    );
  }

  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        width: "15em",
        height: "12em",
        display: "flex",
        overflowY: "auto",
        justifyItems: "center",
        flexDirection: "column",
      }}>
        <Row title="Status:" value={this.properties.status} />
        <Row title="Tipo:" value={this.properties.tipo} />
        {this.properties.proprietario && <Row title="Proprietário" value={this.properties.proprietario} />}
        <Row title="Total de pessoas:" value={(this.properties.qtdPessoas ?? 0).toString()} />
        <Row title="Com comorbidade:" value={(this.properties.qtdComorbidade ?? 0).toString()} />
        <Row title="Dificuldade de locomoção:" value={(this.properties.qtdLocomocao ?? 0).toString()} />
        <ObservationRow title="Observação:" value={this.properties.obs ?? ""}/>
      </div>
    );
  }
}

interface PropsIcon {
  src: string;
  text: string;
  iconSize: number;
}
const IconData: React.FC<PropsIcon> = ({ src, iconSize, text }) => {
  const theme = useTheme();

  return <ThemeProvider theme={theme}>
    <img
      src={src}
      alt={text}
      style={{
        objectFit: "contain",
        height: `${iconSize}px`,
        width: `${iconSize}px`,
      }}
    />
  </ThemeProvider>;
};

interface PropsRow {
  title: string;
  value: string;
}
const Row: React.FC<PropsRow> = (data) => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "1.5em",
      padding: "5px",
      borderRadius: "5px",
    }}>
      <Typography fontSize={"1em"} fontWeight={"bold"}>{data.title}</Typography>
      <div style={{ minWidth: "5px", flex: 1, marginTop: '0.3em', }} />
      <Typography fontSize={"1em"} style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "right",
        maxWidth: '5em',
      }} title={data.value}>
        {data.value}
      </Typography>
    </div>
  );
};

const ObservationRow: React.FC<PropsRow> = ({ title, value }) => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      margin: 0
    }}>
      <Typography fontSize={"1em"} fontWeight={"bold"}
        style={{ marginBottom: '0.2em' }}
      >
        {title}
      </Typography>
      <Typography
        fontSize={"1em"}
        style={{
          wordWrap: "break-word",
          whiteSpace: "normal",
          margin: 0,
        }}
      >
        {value}
      </Typography>
    </div>
  );
};